import MainSlider from "@/components/main/MainSlider"
import SliderSectionTop from "@/components/SliderSectionTop"
import UsefulMatCard from "@/components/useful-materials/UsefulMatCard"
import UsefulMatSlider from "@/components/useful-materials/UsefulMatSlider"
import Link from "next/link"
import { useTranslation } from "react-i18next"

const AdditionalContent = ({pageType, allNews, newsSliderSettings, updatedNews, allMaterials}) => {
    const {t} = useTranslation()

    return (
        <>
            {pageType === 'news' && allNews?.length && (
                <div className='news-details__other-news'>
                    <MainSlider
                        settings={newsSliderSettings}
                        type={'news'}
                        list={allNews ? allNews : updatedNews}
                    />
                </div>
            )}
            {allMaterials && pageType !== 'vacancy' && (
                <>
                    <div className='useful-materials__carousel'>
                        <div className='news-details__section container'>
                            <SliderSectionTop
                                title={t('usefulMaterialsTitle')}
                                linkText={t('watchAll')}
                            />
                        </div>
                        <div className='useful-materials__slider-limiter'>
                            <UsefulMatSlider
                                scroll={605}
                                list={allMaterials?.slice(0, allMaterials?.length / 2)}
                            />
                        </div>
                        <div className='useful-materials__slider-limiter'>
                            <UsefulMatSlider
                                scroll={511}
                                list={allMaterials?.slice(allMaterials?.length / 2)}
                            />
                        </div>
                        <ul className='useful-materials__card-list'>
                            {allMaterials?.length
                                ? allMaterials?.slice(0, 3)?.map(card => (
                                      <UsefulMatCard
                                          key={card.id}
                                          item={card}
                                      />
                                  ))
                                : null}
                            <Link
                                href='/useful-materials'
                                className='useful-materials__link'
                            >
                                <p>смотреть все</p>
                                <svg
                                    width='20'
                                    height='20'
                                    viewBox='0 0 20 20'
                                    fill='none'
                                    xmlns='http://www.w3.org/2000/svg'
                                >
                                    <path
                                        d='M9 15L12.9409 10.5664C12.9746 10.5285 12.9746 10.4715 12.9409 10.4336L9 6'
                                        stroke='#919EBF'
                                        strokeWidth='2'
                                        strokeLinecap='round'
                                    />
                                </svg>
                            </Link>
                        </ul>
                    </div>
                </>
            )}
        </>
    )
}

export default AdditionalContent
